import { useState, useEffect } from 'react';

export const useRadioButton = ({ userProfileForm, modelProp, isUpdated }) => {
    const [classError, setClassError] = useState(false);
    const [trigger, setTrigger] = useState(false);

    useEffect(() => {
        const isValid = userProfileForm?.[modelProp]?.valid;
        setClassError(!isValid);
    }, [userProfileForm, modelProp]);

    useEffect(() => {
        if (!trigger) return;

        const isValid = userProfileForm?.[modelProp]?.valid;
        isValid && isUpdated?.();

        setTrigger(false);
    }, [trigger, userProfileForm, modelProp, isUpdated]);

    return { classError, setTrigger };
};
